export default "__VITE_ASSET__CNxupBJh__"